/*
 *  Service Workbench DCV Integration
 */
import _ from 'lodash';
import React from 'react';
import { decorate, computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';

import ScEnvironmentDcvConnectionRow from './ScEnvironmentDcvConnectionRow';

class ScEnvironmentDcvConnections extends React.Component {
  get environment() {
    return this.props.scEnvironment;
  }

  get connections() {
    return this.environment.getConnections(item => item.scheme === 'dcv');
  }

  get isAppStreamEnabled() {
    return process.env.REACT_APP_IS_APP_STREAM_ENABLED === 'true';
  }

  render() {
    const env = this.environment;
    const state = env.state;
    const canConnect = state.canConnect;
    const empty = _.isEmpty(this.connections);

    if (!canConnect) return null;

    if (empty) {
      return this.renderEmpty();
    }

    return this.renderConnections();
  }

  renderAppStreamInfo() {
    return (
      <div className="connection-info-box" style={{ background: '#fef3c7', borderColor: '#fcd34d' }} data-testid="appstream-instructions-dcv">
        <Icon name="warning sign" style={{ color: '#92400e' }} />
        <div className="connection-info-box-content" style={{ color: '#92400e' }}>
          <b>AppStream Not Supported</b>
          <div>NICE DCV connections are not available through AppStream.</div>
        </div>
      </div>
    );
  }

  renderConnections() {
    const env = this.environment;
    const connections = this.connections;

    return (
      <div className="connection-card fadeIn animated">
        <div className="connection-card-header">
          <div className="connection-card-title">
            <Icon name="tv" />
            Amazon DCV Connection (GUI)
          </div>
        </div>
        <div className="connection-card-body">
          <div className="connection-intro">
            This opens a graphical desktop session to your Linux workspace, similar to using a regular computer.
            Choose <b>Open in Browser</b> for instant access with no software required, or <b>Open in DCV Client</b> for
            better performance (requires the <a href="https://www.amazondcv.com/" target="_blank" rel="noopener noreferrer">Amazon DCV Client</a>).
          </div>
          {this.isAppStreamEnabled && this.renderAppStreamInfo()}
          {_.map(connections, item => (
            <ScEnvironmentDcvConnectionRow key={item.id} scEnvironment={env} connectionId={item.id} />
          ))}
          <div className="connection-help-link">
            <Icon name="question circle outline" style={{ margin: 0, lineHeight: 1, height: '1em' }} />
            Need help? Visit the <a href="/documentation">Documentation</a> for detailed guides.
          </div>
        </div>
      </div>
    );
  }

  renderEmpty() {
    return (
      <div className="connection-card">
        <div className="connection-empty">
          <Icon name="tv" />
          <div className="connection-empty-title">No DCV Connections</div>
          <div className="connection-empty-text">This workspace does not have any NICE DCV connections.</div>
        </div>
      </div>
    );
  }
}

decorate(ScEnvironmentDcvConnections, {
  environment: computed,
  connections: computed,
});

export default inject()(withRouter(observer(ScEnvironmentDcvConnections)));
